import { render, staticRenderFns } from "./lazyblock_abstract.vue?vue&type=template&id=978b34ec&scoped=true"
import script from "./lazyblock_abstract.vue?vue&type=script&lang=js"
export * from "./lazyblock_abstract.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_abstract.vue?vue&type=style&index=0&id=978b34ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978b34ec",
  null
  
)

export default component.exports